import React from 'react';
import Header from '../common/header/header';
import Footer from '../common/footer/footer';
import './login.css';
import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth, REMEMBER_ME_TOKEN, API_DOMAIN, EMAIL_TRANSFER_TOKEN, UI_DOMAIN, axiosInstance, cookieAppConfig, cookieConfig } from './../../constants/server.constant';
import ReCAPTCHA from "react-google-recaptcha";
import SessionService from '../../services/session.service';
import ReactTooltip from 'react-tooltip';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import Validate from '../common/validate';
import { loginService } from '../../services/login.service';
import { userService } from '../../services/user.service';
import PopupWindow from './popupWindow';
import { parseRedirect, toQuery } from '../../utility/utility';
import * as Cookies from "js-cookie";

class Login extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hidePwd: true,
            isPwdShown: false,
            isChecked: false,
            rememberMe: false,
            username: "",
            password: "",
            isUsernameEmpty: false,
            isPasswordEmpty: false,
            loading: true,
            wrongcreds: false,
            loggedIn: false,
            isAction: false,
            errmsg: false,
            accountCancel: false,
            isCancelledUser: false,
            emailverify: false,
            isNonPaymentUser: false,
            isEmailVerify: false,
            count: 0,
            resetMessage: false,
            isRefreshing: false,
            redirect: ``,
            isRedirectParamPresent: false,
            redirectToParam: SessionService.getCookie("_redirect_url"),
            isActionPendingVerification: false
        };
        this.userNameFocus = React.createRef();
        this.passwordFocus = React.createRef();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleInputs = this.handleInputs.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.loadcss = this.loadcss.bind(this);
        this.recaptchaRef = React.createRef();
        this.nameInput = React.createRef();
        this.inputFocus = this.inputFocus.bind(this);

    }

    inputFocus = (event, param) => {
        if(this.state.username.length <= 0) {
            this.setState({
                isUsernameEmpty: true, isUsernameError: undefined
            });
        } else {
            this.setState({
                isUsernameEmpty: false
            });

        }
    };

    componentDidMount() {
        //asyncCall().then(() => this.setState({ loading: false }));
        //this.loadcss()
        document.title = "IDrive® Compute | Sign In";
        let params = queryString.parse(this.props.location.search);
        console.debug(params);
        if(Object.keys(params).length > 0) {
            if(params.email === "1") {
                this.setState({
                    emailVerify: true
                });
            }
            if(typeof params.url !== 'undefined') {
                this.setState({
                    isRedirectParamPresent: true,
                    redirectToParam: params.url
                });
                let redirectConfig = cookieConfig;
                redirectConfig.path = "/app";
                redirectConfig.expires = new Date(new Date().getTime() + 5 * 60 * 1000);
                SessionService.setCookie("_redirect_url", params.url, redirectConfig);
            }
            if(params.etxtoken) {
                this.setState({
                    isActionPendingVerification: true
                }, () => {
                    sessionStorage.actionPendingVerificationBannerTimeout = setTimeout(() => {
                        this.setState({
                            isActionPendingVerification: false
                        });
                    }, 10000);
                });
                let etxConfig = cookieConfig;
                etxConfig.path = "/api";
                etxConfig.expires = new Date(new Date().getTime() + 5 * 60 * 1000);
                SessionService.setCookie(EMAIL_TRANSFER_TOKEN, params.etxtoken, etxConfig);
                let redirectConfig = cookieConfig;
                redirectConfig.path = "/app";
                redirectConfig.expires = new Date(new Date().getTime() + 5 * 60 * 1000);
                SessionService.setCookie("_redirect_url", "/index", redirectConfig);
                if(SessionService.getCookie("isLoggedIn") && typeof localStorage.getItem("userId") !== 'undefined') {
                    loginService.logoutUser(localStorage.getItem("userId")).then(response => {
                        console.debug(response);
                        loginService.clearLocalSession(localStorage.getItem("userId"));
                    }).catch(error => {
                        console.error("Error while logging out user ...");
                        console.error(error);
                    });
                }
            }
            if(params?.username) {
                this.setState({
                    username: decodeURIComponent(params.username),
                });
            }
        }
        if(this.props.location.state !== undefined) {
            if(this.props.location.state.fromEmailPage) {
                this.setState({
                    emailverify: true
                });
            }
            else if(this.props.location.state.fromEmailVerify) {
                this.setState({
                    username: this.props.location.state.email
                });
            }
            else if(this.props.location.state.fromResetPass) {
                this.setState({
                    resetMessage: true
                });
            }
            else if(this.props.location.state?.fromPrivateRoute) {
                // do nothing
            }
            else {
                this.setState({
                    accountCancel: true
                });
            }

        } else {
            if(typeof SessionService.getCookie(REMEMBER_ME_TOKEN) !== 'undefined') {
                this.setState({ isRefreshing: true });
                Axios.get(API_HOST + "/login/authenticate/refresh", axiosRequestWithAuth).then(resp => {
                    // console.log("New session established with refresh token");
                    if(resp?.data?.redirect) {
                        this.props.history.push(resp.data.redirect);
                    }
                    userService.getUserData().then(resp => {
                        this.setState({ redirect: '/index', isRefreshing: false });
                    }).catch(err => {
                        loginService.redirectToLogin();
                    });
                }).catch(error => {
                    // console.log("Unable to establish previous session: " + error?.response?.status);
                    this.setState({ isRefreshing: false });
                });
            }
        }
        sessionStorage.tempTimeout = setTimeout(() => {
            this.setState({
                accountCancel: false,
                resetMessage: false
            });
        }, 20000);
    }

    componentWillUnmount = () => {
        clearTimeout(sessionStorage.tempTimeout);
        clearTimeout(sessionStorage.actionPendingVerificationBannerTimeout);
    };

    loadcss = () => {
        document.title = "IDrive® Compute | Sign In";
        // const link = document.createElement("link")
        // link.href = "https://www.idrivecompute.com/webapp/css/login-page.css"
        // link.rel = "stylesheet"
        // link.type = "text/css"
        // document.head.appendChild(link)

        // const link1 = document.createElement("link")
        // link1.href = "https://www.idrivecompute.com/webapp/css/static-common.css"
        // link1.rel = "stylesheet"
        // link1.type = "text/css"
        // document.head.appendChild(link1)
    };

    handleToggle(event) {

        if(event.target.type === "checkbox") {
            this.setState({
                isChecked: !this.state.isChecked
            });
        }
        else {
            this.setState({
                hidePwd: !this.state.hidePwd,
                isPwdShown: !this.state.isPwdShown,

            });
        }
    }

    handleRememberMeToggle = (event) => {
        this.setState({ rememberMe: !this.state.rememberMe });
    };

    handleInputs(event) {
        this.setState({
            wrongcreds: false,
            isCancelledUser: false,
            accountCancel: false,
            isNonPaymentUser: false
        });

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            [name]: val
        });
        if(name === "username") {
            if(val.length > 0) {
                this.setState({
                    isUsernameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    isUsernameEmpty: true, isUsernameError: undefined
                });
            }

        }
        if(name === "password") {
            if(val.length > 0) {
                this.setState({
                    isPasswordEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    isPasswordEmpty: true
                });
            }
        }
    }

    onRecaptchaChange = (event) => {
        this.doAuthentication(event);
    };

    doAuthentication(event, email, tokenId, githubCode) {
        localStorage.removeItem('phone');
        localStorage.removeItem('countryCode');
        this.setState({
            isAction: true
        });
        //var captcha_response = $("#g-recaptcha-response").val();
        //console.log(captcha_response)
        let reqObj, authUrl;
        authUrl = API_HOST + '/login/thirdPartyAuthenticate';
        if(tokenId) {
            reqObj = JSON.stringify({
                email: email,
                password: '',
                rememberMe: this.state.rememberMe,
                googleAuthToken: tokenId,
            });
            this.setState({ isFullPageAction: true, isAction: false, username: email, password: "" });
        } else if(githubCode) {
            reqObj = JSON.stringify({
                email: email,
                password: '',
                rememberMe: this.state.rememberMe,
                githubCode: githubCode,
            });
            this.setState({ isFullPageAction: true, isAction: false, username: email, password: "" });
        } else {
            authUrl = API_HOST + '/login/authenticate?captcha=' + event;
            reqObj = JSON.stringify({
                email: this.state.username.trim(),
                password: this.state.password,
                rememberMe: this.state.rememberMe,
                redirectTo: this.state.redirectToParam
            });
        }
        Axios.post(authUrl, reqObj, axiosRequestWithAuth).then((authResp) => {
            console.log(authResp);
            if(!authResp?.data?.error) {
                if(String(authResp.data?.redirect).startsWith("/2fa") || String(authResp.data?.redirect).startsWith("/email-confirmation")) {
                    userService.getUserData().then((response) => {
                        if(response.data.emailVerify !== 1 && response.data.role.id === 2) {
                            localStorage.setItem("_email_verify", response.data.email);
                        }
                        else {
                            localStorage.removeItem("_email_verify");
                        }
                        loginService.setUserLocal(response, true);
                        this.setState({ redirect: authResp.data?.redirect });
                    }).catch((error) => {
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }
                        this.setState({
                            wrongcreds: true,
                            errmsg: "Error while trying to connect",
                            isAction: false,
                            isFullPageAction: false
                        });
                    });
                }
                else {
                    if(authResp.data?.emailTransfer) {
                        this.setState({ "emailTransfer": authResp.data?.emailTransfer });
                    }
                    userService.getUser().then((response) => {
                        if(response.data.emailVerify !== 1 && response.data.role.id === 2) {
                            localStorage.setItem("_email_verify", response.data.email);
                        }
                        else {
                            localStorage.removeItem("_email_verify");
                        }
                        loginService.setUserLocal(response, true);
                        if(SessionService.getCookie("_redirect_url")) this.setState({ redirect: SessionService.getCookie("_redirect_url") });
                        else this.setState({ redirect: authResp.data?.redirect });
                    }).catch((error) => {
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }
                        this.setState({
                            wrongcreds: true,
                            errmsg: "Error while trying to connect",
                            isAction: false,
                            isFullPageAction: false
                        });
                    });
                }

            }
            else {
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
                this.setState({
                    wrongcreds: true,
                    errmsg: "Invalid Email or Password",
                    isAction: false,
                    isFullPageAction: false
                });
                if(email) {
                    this.setState({ username: email, password: '' });
                    this.passwordFocus.current.value = '';
                }
            }
        }, (error) => {
            if(email) {
                this.setState({ username: email, password: '' });
                this.passwordFocus.current.value = '';
            }
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            let message = error.response.data;
            if(message.status === 500) {
                this.setState({
                    wrongcreds: true,
                    isCancelledUser: false,
                    accountCancel: false,
                    errmsg: "Error while connecting, try again",
                    isAction: false,
                    isFullPageAction: false
                });
            }
            else if(message.indexOf("Invalid") !== -1) {
                this.setState({
                    wrongcreds: true,
                    isCancelledUser: false,
                    isNonPaymentUser: false,
                    accountCancel: false,
                    errmsg: "Invalid Email or Password",
                    isAction: false,
                    isFullPageAction: false
                });
            }
            else if(message.indexOf("payment") !== -1) {
                this.setState({
                    wrongcreds: false,
                    isCancelledUser: false,
                    isNonPaymentUser: true,
                    accountCancel: false,
                    errmsg: message,
                    isAction: false,
                    isFullPageAction: false
                });
            }
            else {
                this.setState({
                    wrongcreds: false,
                    isCancelledUser: true,
                    isNonPaymentUser: false,
                    accountCancel: false,
                    errmsg: message,
                    isAction: false,
                    isFullPageAction: false
                });
            }
        }
        );
    }

    submitForm(event) {
        event.preventDefault();

        if(!(this.state.password.length > 0)) {
            this.setState({
                isPasswordEmpty: true
            });
            this.passwordFocus.current.focus();

        }
        if(!(this.state.username.length > 0)) {
            this.setState({
                isUsernameEmpty: true, isUsernameError: undefined
            });
            this.userNameFocus.current.focus();
        }

        if(this.state.password.length > 0 && this.state.username.length > 0) {
            this.recaptchaRef.current.execute();
        }
    }

    sucessResponseGoogle = (response) => {
        this.setState({ isUsernameError: false, rememberMe: false });
        if(response && response.profileObj && response.profileObj.email) {
            this.doAuthentication('', response.profileObj.email, response.tokenId);
        }
    };

    errorResponseGoogle = (response) => {
        console.log(response);
    };

    sucessResponseGithub = (res) => {
        if(!res.code) {
            return null;
            //return this.onFailure(new Error('\'code\' not found'));
        }
        this.setState({
            isAction: true,
            rememberMe: false,
        });
        const axiosHeaders = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        };
        Axios.post(API_HOST + "/login/authenticate/github/user-details", { "gitCode": res.code }, axiosHeaders)
            .then(resp => {
                this.doAuthentication('', resp.data, '', res.code);
            })
            .catch(err => console.log(err));

        // this.setState({isUsernameError:false})
        // if(response && response.profileObj && response.profileObj.email) {
        //     this.doAuthentication('',response.tokenId,response.profileObj.email);
        // }
    };

    errorResponseGithub = (response) => {
        console.log(response);
    };

    userNameBlur = () => {
        if(this.state.username && this.state.username.length > 0 && !Validate("email", this.state.username)) {
            this.setState({
                isUsernameError: "Email is invalid"
            });
        } else {
            this.setState({ isUsernameError: undefined });
        }
    };

    passwordBlur = (e) => {
        if(this.state.password.length <= 0) {
            this.setState({
                isPasswordEmpty: true,
            });
        } else {
            this.setState({
                isPasswordEmpty: false,
            });
        }
    };

    onGithubBtnClick = (e) => {
        //const { clientId, scope, redirectUri } = this.props;
        const search = toQuery({
            client_id: "c4fbf9ea5a443ab9b27a",
            scope: "user:email",
            redirect_uri: "https://www.idrivecompute.com/app/login/oauth2/code/github",
        });
        console.log(`https://github.com/login/oauth/authorize?${ search }`);
        const popup = this.popup = PopupWindow.open(
            'github-oauth-authorize',
            `https://github.com/login/oauth/authorize?${ search }`,
            { height: 1000, width: 600 }
        );

        //this.onRequest();
        popup.then(

            data => {
                this.sucessResponseGithub(data); console.log("data " + data.code);
            },
            error => this.errorResponseGithub(error)
        );
    };

    triggerClick = (name) => {
        if(name === 'google') $('#googleBtn').trigger('click');
        if(name === 'github') $('#githubBtn').trigger('click');
    };

    render() {

        // const loading = this.state.loading;
        // if(!sessionStorage.signupLoaded && loading) {  
        //  return null; 
        // }
        // sessionStorage.signupLoaded = true;
        try {
            if(this.state.isRefreshing) {
                return null;
            } else {
                if(SessionService.getCookie("isLoggedIn") && this.state.redirect !== ``) {
                    let redirect = parseRedirect(this.state.redirect);
                    redirect.state = {
                        fromLogin: true,
                    };
                    if(this.state.emailTransfer) redirect.state.emailTransfer = this.state.emailTransfer;
                    return <Redirect to={ redirect } replace={ true }></Redirect>;
                }
                return (
                    <div>
                        <Header />
                        <main className="static">
                            <div className="full_page_loader" style={ { display: this.state.isFullPageAction ? 'block' : 'none' } }>
                                <div className="loader_icon"></div>
                            </div>
                            <div id="static_form_wrap" className="githubWrap">
                                <div className="sign_in_bg"></div>
                                <div className="wrapper">
                                    <div className="box_center_align box_fifty">
                                        <form id="signin-form" onSubmit={ this.submitForm }>
                                            <div className="box_header_text">
                                                <h1>Sign in to IDrive<sup>&reg;</sup> Compute</h1>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.isCancelledUser ? "block" : "none" } }>
                                                <div className="common_msg error ">
                                                    <div className="icon"></div>
                                                    <div className="info">
                                                        <strong>You are trying to access a canceled account.</strong><br></br>
                                                        { this.state.errmsg }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.isNonPaymentUser ? "block" : "none" } }>
                                                <div className="common_msg error ">
                                                    <div className="icon"></div>
                                                    <div className="info">
                                                        Your payment could not be processed. All your instances will be shut down. <a href='https://www.idrivecompute.com/support.htm' target="_blank" rel='noopener noreferrer'>Contact support</a> for assistance.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.accountCancel ? "block" : "none" } }>
                                                <div className="common_msg success ">
                                                    <div className="icon" style={ { width: "40px" } }></div>
                                                    <div className="info">
                                                        Your account has been canceled </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.resetMessage ? "block" : "none" } }>
                                                <div className="common_msg success ">
                                                    <div className="icon" style={ { width: "40px" } }></div>
                                                    <div className="info">
                                                        The password has been reset </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.emailverify ? "block" : "none" } }>
                                                <div className="common_msg success ">
                                                    <div className="icon" style={ { width: "40px" } }></div>
                                                    <div className="info"> Email verification is complete and you can now use your account </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.isActionPendingVerification ? "block" : "none" } }>
                                                <div className="common_msg success">
                                                    <div className="info">Sign in to verify your identity</div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.wrongcreds ? "block" : "none" } }>
                                                <div className="common_msg error">
                                                    <div className="icon"></div>
                                                    <div className="info">{ this.state.errmsg }</div>
                                                </div>
                                            </div>
                                            <div className="box_inner_wrap">
                                                <div className="box-left">

                                                    <div className="inp_row email">
                                                        <label>Email</label>
                                                        <input ref={ this.userNameFocus } value={ this.state.username } autoFocus id="nameinput" type="text" name="username" className="txt-box" autoComplete='off' onChange={ this.handleInputs } onBlur={ () => { this.userNameBlur(); } } tabIndex='1'></input>
                                                        <i className="email_ico"></i>
                                                        { this.state.isUsernameError ? <span className="error_msg" style={ { display: 'block' } }> { this.state.isUsernameError } </span> : "" }
                                                        { this.state.isUsernameEmpty ? <span className="error_msg" style={ { display: 'block' } }>Email cannot be blank</span> : "" }
                                                    </div>
                                                    <div className="inp_row pswd">
                                                        <label>Password</label>
                                                        <div className=" pwd_field_wrap">
                                                            <input type={ this.state.hidePwd ? "password" : "text" } ref={ this.passwordFocus } name="password" className="txt-box" onChange={ this.handleInputs } onClick={ (e) => this.inputFocus(e, "pass") } onFocus={ (e) => this.inputFocus(e, "pass") } onBlur={ () => { this.passwordBlur(); } } tabIndex='2'></input>
                                                            <i className="pswd_ico"></i>
                                                            <span data-tip data-for="password" className={ this.state.isPwdShown ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } onClick={ this.handleToggle }></span>
                                                        </div><ReactTooltip id="password" place="right" effect="solid">
                                                            { this.state.isPwdShown ? "Hide" : "Show" }
                                                        </ReactTooltip>
                                                        { this.state.isPasswordEmpty ? <span className="error_msg" style={ { display: "block" } } >Password cannot be blank</span> : "" }
                                                    </div>
                                                    <div className="optionBox">
                                                        <div className="checkbox_sec">
                                                            <div className="checkbox_wrap">
                                                                <input type="checkbox" name="remember_me" id="remember_me" className="checkbox_option" checked={ this.state.rememberMe } onChange={ this.handleRememberMeToggle } onFocus={ (e) => this.inputFocus(e, "remember_me") } tabIndex='3' />
                                                                <label htmlFor="remember_me">Remember me</label>
                                                            </div>
                                                        </div>
                                                        <div className="pwd_forget pwd_forget_link"><Link to="/forgot-password" tabIndex={ '4' }>Forgot your password?</Link></div>
                                                    </div>
                                                    <div className="checkbox_sec" style={ { display: "none" } }>
                                                        <div className="checkbox_wrap">
                                                            <input type="checkbox" name="trust_device" checked={ this.state.isChecked } id="trust_device" className="checkbox_option" onChange={ this.handleToggle }></input>
                                                            <label htmlFor="trust_device">Trust this device for 60 days?</label>
                                                        </div>
                                                    </div>

                                                    <div className="captcha_wrap">

                                                    </div>

                                                    <div className="footer_wrap">
                                                        <div className={ this.state.isAction ? "btn_wrap loginSubmitLoader" : "btn_wrap" }>
                                                            <input type="submit" name="" value={ this.state.isAction ? "" : "Sign in" } className={ this.state.isAction ? "btn-primary g-recaptcha disbaled" : "btn-primary g-recaptcha" } data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" onFocus={ (e) => this.inputFocus(e, "submit") } tabIndex='5'></input>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="box-middle">
                                                    <div className="other_option_wrap"> Or</div>
                                                </div>
                                                <div className="box-right">
                                                    <GoogleLogin
                                                        clientId="537979516794-mcln2pq1tg3b01rq473co7g3suu62bl7.apps.googleusercontent.com"
                                                        buttonText="Login"
                                                        onSuccess={ (e) => this.sucessResponseGoogle(e) }
                                                        onFailure={ (e) => this.errorResponseGoogle(e) }
                                                        cookiePolicy={ 'single_host_origin' }
                                                        prompt={ 'consent' }
                                                        render={ renderProps => (
                                                            <div tabIndex={ '6' } className="google_btn-primary" id="googleBtn" onKeyPress={ () => this.triggerClick('google') } onClick={ renderProps.onClick } disabled={ renderProps.disabled }>
                                                                <span className="icon">
                                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" className="abcRioButtonSvg">
                                                                        <g>
                                                                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                                                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                                                            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                                                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                                                            <path fill="none" d="M0 0h48v48H0z"></path>
                                                                        </g>
                                                                    </svg>
                                                                </span>
                                                                <span className="signin_content">Sign in with Google</span>
                                                            </div>

                                                        ) }
                                                    >GoogleLogin
                                                        <span> Sign in with Google</span>
                                                    </GoogleLogin>
                                                    <div>
                                                        <div tabIndex={ '7' } className="github-btn-primary" onClick={ e => this.onGithubBtnClick(e) } onKeyPress={ () => this.triggerClick('github') } id="githubBtn">
                                                            <span className="icon">
                                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 30 30" className="abcRioButtonSvg">
                                                                    <path d="M15,0.3C6.8,0.3,0.1,7,0.1,15.2c0,7,4.8,12.8,11.3,14.5c-0.1-0.2-0.1-0.4-0.1-0.7v-2.5c-0.6,0-1.6,0-1.9,0
                                                                        c-1,0-1.9-0.4-2.4-1.3c-0.5-0.9-0.6-2.3-1.8-3.1c-0.4-0.3-0.1-0.6,0.3-0.6c0.8,0.2,1.4,0.7,2,1.5c0.6,0.8,0.9,1,2,1
                                                                        c0.5,0,1.3,0,2.1-0.2c0.4-1,1.1-2,2-2.4c-5-0.5-7.3-3-7.3-6.3c0-1.4,0.6-2.8,1.7-4C7.6,9.8,7.2,7.4,8.1,6.5c2.2,0,3.6,1.4,3.9,1.8
                                                                        c1.1-0.4,2.3-0.6,3.6-0.6c1.3,0,2.5,0.2,3.6,0.6c0.3-0.4,1.7-1.8,3.9-1.8c0.9,0.9,0.5,3.3,0.1,4.5c1,1.2,1.7,2.6,1.7,4
                                                                        c0,3.4-2.4,5.8-7.3,6.3c1.4,0.7,2.4,2.7,2.4,4.2V29c0,0.1,0,0.2,0,0.3c5.8-2,10-7.6,10-14.1C29.9,7,23.2,0.3,15,0.3z"></path>
                                                                </svg>
                                                            </span>
                                                            <span className="signin_content">Sign in with GitHub</span>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>


                                            {/* <div className="new_acc_wrap"> <Link to="/signup" tabIndex={ '8' }>Don't have an account? Sign up</Link> </div> */ }

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </main>
                        <div className="clear"></div>
                        <Footer />
                        <div className="captcha">
                            <ReCAPTCHA
                                sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                                onChange={ (e) => this.onRecaptchaChange(e) }
                                ref={ this.recaptchaRef }
                                size="invisible"
                                tabIndex={ '9' }
                            />
                        </div>
                    </div>
                );
            }
        }
        catch(e) {
            return (
                <Redirect to="/login" />
            );
        }
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}

export default Login;
